import { Backdrop, BoxProps, LinearProgress, styled } from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import Logo from "@/components/Logo";

const ImageContainer = styled(Box)<BoxProps>((/*{ theme }*/) => ({
    "&.MuiBox-root": {
        //background: theme.palette.secondary.dark,
        height: '140px',
        color: "#fff",
        borderRadius: "10px",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
}));


const StyledImage = styled(Logo)(() => ({
    width: "150px"
}));


const ModuleFallBack: React.FC = () => {

    return (
      <Backdrop sx={{ zIndex: 999, background: '#FAFAFA' }} open={true}>
        <Box sx={{ textAlign: 'center' }}>
          <ImageContainer sx={{ mb: 2 }}>
            <StyledImage />
          </ImageContainer>

          <LinearProgress
            sx={{
              height: '8px',
              width: '100%',
              borderRadius: '8px',
            }}
            variant='indeterminate'
            color='secondary'
          />
        </Box>
      </Backdrop>
    );
}

export default ModuleFallBack